import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';

const captionDuration = 10; // Seconds.

const getDataFromCaptionNode = function (node) {
    const keys = ['trigger'];
    return filterNodeProperties(node, keys, {val: node.val});
};

const formatCaptionList = function (captionList) {
    // Get the time (seconds) of the last caption.
    const lastCaptionStartTime = Math.round(parseFloat(captionList[captionList.length - 1].trigger));
    // The last caption will end + N seconds after the last one starts.
    const totalSecondsTime = lastCaptionStartTime + captionDuration;
    /* This is a "filler" caption so we can control the duration of the last caption. If we don't do this then we would
    have to define another setTimeout/setInterval just for this last caption. */
    captionList.push({val: null, trigger: totalSecondsTime});

    let captionsObject = {};
    captionList.forEach(function (caption) {
        // Seconds in the XML may be decimals (10.5, for example). Rounding them here shouldn't be a problem.
        captionsObject[Math.round(parseFloat(caption.trigger))] = caption.val;
    });

    return {captionsObject, totalSecondsTime};
};

const getStateFromProps = function (props = {}) {
    const captionNodes = props.node.childrenNamed('caption_node').map(node => {
        return getDataFromCaptionNode(node);
    });
    const {captionsObject, totalSecondsTime} = formatCaptionList(captionNodes);

    return {
        text: '',
        captionEnded: false,
        type: props.type,
        captionsObject,
        totalSecondsTime
    };
};

class CaptionsNode extends React.Component {

    constructor(props) {
        super(props);

        this.intervalTimer = null;
        this.tick = 0;
        this.intervalDelay = 1000; // 1 second. The time interval used to check for presence of caption.
        this.state = {
            ...getStateFromProps(props)
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.node !== nextProps.node) {
            this.setState({
                ...getStateFromProps(nextProps)
            });
        }
    }

    componentDidMount() {
        clearInterval(this.intervalTimer);
        this.intervalTimer = setInterval(this.runCaption.bind(this), this.intervalDelay);
    }

    componentWillUnmount() {
        clearInterval(this.intervalTimer);
    }

    videoPlay() {
        clearInterval(this.intervalTimer);
        this.intervalTimer = setInterval(this.runCaption.bind(this), this.intervalDelay);
    }

    audioPlay() {
        clearInterval(this.intervalTimer);
        this.intervalTimer = setInterval(this.runCaption.bind(this), this.intervalDelay);
    }

    runCaption() {
        const {totalSecondsTime, captionsObject} = this.state;
        let tick = parseInt(this.tick);

        if (!this.props.pause) {
            this.tick += 1;
        }

        const captionText = captionsObject[tick];
        if (captionText !== undefined && captionText) {
            this.setState({text: captionsObject[tick]});
        }

        if (tick >= totalSecondsTime) {
            this.clearCaption();
        }
    }

    clearCaption() {
        clearInterval(this.intervalTimer);
        this.tick = 0;
        this.setState({captionEnded: true, totalSecondsTime: 0});
    }

    renderVideoCaption() {
        const {text = ''} = this.state;
        const {fullHeightVideo = ''} = this.props;

        if (!text) {
            return null;
        }

        if(fullHeightVideo) {
            return (
                <div className="node caption-outer-video-container">
                    <div className="caption-inner-container">
                        <div className="caption" dangerouslySetInnerHTML={{__html: text}}/>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="caption-inner-container">
                    <div className="caption" dangerouslySetInnerHTML={{__html: text}}/>
                </div>
            );
        }
    }

    renderAudioCaption() {
        const {text = ''} = this.state;

        if (!text) {
            return null;
        }

        return (
            <div className="node caption-outer-container">
                <div className="caption-inner-container">
                    <div className="caption" dangerouslySetInnerHTML={{__html: text}} />
                </div>
            </div>
        );
    }

    render() {
        const {type = '', captionEnded = false} = this.state;
        const {captionsFlag} = this.props;

        const captionStyle = {
            display: (captionsFlag && !captionEnded) ? 'block' : 'none'
        };
        return (
            <div style={captionStyle}>
                {(type === 'video') ? this.renderVideoCaption() : this.renderAudioCaption()}
            </div>
        );
    }
}

CaptionsNode.propTypes = {
    node: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return {
        captionsFlag: state.captionsFlag,
    };
};

const CaptionsNodeContainer = connect(
    mapStateToProps, null
)(CaptionsNode);

export default CaptionsNodeContainer;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/captions-node.js